export default __webpack_public_path__ + "static/media/iconRefresh.b6a061b0.gif";